import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=13370500&scoped=true&"
import script from "./PaymentInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PaymentInfo.vue?vue&type=style&index=1&id=13370500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13370500",
  null
  
)

export default component.exports